require('./bootstrap');

import { flare } from '@flareapp/flare-client';
import { flareVue } from '@flareapp/flare-vue';

import Vue from 'vue';
require('./components');
var numeral = require('numeral');

import VueI18n from 'vue-i18n';
import { messages } from './lang';

if (process.env.APP_ENV === 'production') {
    flare.light(process.env.MIX_FLARE_JS);
    Vue.use(flareVue);
}

import VueAwesomeSwiper from 'vue-awesome-swiper';
import '../../public/plugins/swiper/swiper.min.css';

import VueMasonry from 'vue-masonry-css';
import { Model } from 'vue-api-query';
import VueToastr from 'vue-toastr';
import Fragment from 'vue-fragment';
import PortalVue from 'portal-vue';
import VueMask from 'v-mask';

import triggerRemoveNavActiveEl from './mixins/triggerRemoveNavActiveEl';
import stickyNavActiveLink from './mixins/sitcky-nav-active-link';
import showComponents from './mixins/showComponents';
import clickOutside from './directives/click-outside';
import scrollButton from './mixins/scrollButton';
import chatModal from './mixins/chatModal';
import navbar from './mixins/navbar';
import auth from './mixins/auth';

Model.$http = axios;

Vue.directive('click-outside', clickOutside);

Vue.use(VueMasonry);
Vue.use(PortalVue);
Vue.use(VueAwesomeSwiper);
Vue.use(VueToastr, {
    defaultPosition: 'toast-top-right'
});
Vue.use(VueMask);
Vue.use(Fragment.Plugin);

Vue.filter('decimalFormat', function(value) {
    return numeral(value).format('0.00');
});

Vue.filter('cents', function(value) {
    return (value - Math.floor(value)).toFixed(2).split('.')[1];
});

Vue.filter('truncate', function(value, length, clamp) {
    clamp = clamp || '...';
    return value.length > length ? value.slice(0, length) + clamp : value;
});

Vue.filter('price', function(value) {
    return numeral(value).format('0,0.00');
});

import store from './store/buyer';
import debounce from 'lodash/debounce';

const isEnLocale = window.location.href.includes('/en/') || window.location.href.endsWith('/en');

Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: isEnLocale ? 'en' : 'mne',
    messages
});

const app = new Vue({
    el: '#app',
    i18n,
    store,
    data() {
        return {
            componentsReady: false
        };
    },
    components: {
        TwoFactorAuth: () => import('./pages/buyer/user/two-factor-auth/TwoFactorAuth'),
        NotificationCenter: () => import('./pages/notification/NotificationCenter'),
        NavbarButtons: () => import('./pages/buyer/landing/partials/NavbarButtons'),
        ProductsGrid: () => import('./pages/buyer/products/partials/ProductsGrid'),
        UserDropdown: () => import('./pages/buyer/landing/partials/UserDropdown'),
        ChooseRegisterMethod: () => import('./pages/auth/ChooseRegisterMethod'),
        AcceptInvitation: () => import('./pages/market/staff/AcceptInvitation'),
        Collections: () => import('./pages/buyer/store-preview/Collections'),
        StoreProducts: () => import('./pages/buyer/store-preview/Products'),
        SimpleOrder: () => import('./pages/buyer/simple-order/SimpleOrder'),
        ChooseInterests: () => import('./pages/auth/ChooseInterests'),
        RegisterAddress: () => import('./pages/auth/RegisterAddress'),
        ProductPreview: () => import('./pages/buyer/product/Preview'),
        Settings: () => import('./pages/buyer/user/settings/Settings'),
        WishList: () => import('./pages/buyer/wish-list/WishList'),
        RegisterPhone: () => import('./pages/auth/RegisterPhone'),
        ShowOrders: () => import('./pages/my-orders/ShowOrders'),
        Products: () => import('./pages/buyer/products/Products'),
        OrderBill: () => import('./pages/buyer/order/OrderBill'),
        Carousel: () => import('./pages/buyer/landing/Carousel'),
        Interests: () => import('./pages/buyer/user/Interests'),
        Gallery: () => import('./pages/buyer/product/Gallery'),
        Addresses: () => import('./pages/buyer/user/Addreses'),
        Reviews: () => import('./pages/buyer/product/Reviews'),
        VerifyPhone: () => import('./pages/auth/VerifyPhone'),
        Navbar: () => import('./pages/buyer/landing/Navbar'),
        MyStores: () => import('./pages/my-stores/Stores'),
        Session: () => import('./pages/buyer/user/Session'),
        Stores: () => import('./pages/buyer/stores/Stores'),
        Order: () => import('./pages/buyer/order/Order'),
        Cart: () => import('./pages/buyer/cart/index.vue'),
        Faq: () => import('./pages/buyer/faq/Faq'),
        Chat: () => import('./pages/chat/Chat'),
    },
    computed: {
        appReady() {
            return this.user !== null && [null, true].includes(this.componentsReady);
        }
    },
    updated: debounce(function () {
        this.$nextTick(() => {
            this.componentsReady = true;
        })
    }, 50),
    mixins: [navbar, auth, scrollButton, showComponents, chatModal, stickyNavActiveLink, triggerRemoveNavActiveEl]
});
